import { Pipe, PipeTransform } from '@angular/core';
import { Address, NgcApiLocation } from '@ncg/data';
import stringify from 'fast-safe-stringify';
@Pipe({
    name: 'sortLocationsBy',
    standalone: true,
})
export class SortLocationsByPipe implements PipeTransform {
    public transform(locations: NgcApiLocation[], sortBy: Extract<keyof Address, 'city' | 'zipcode'>): NgcApiLocation[] {
        // Deep clone to avoid changing original array
        const locationsToSort: NgcApiLocation[] = JSON.parse(stringify(locations));
        return locationsToSort.sort((a, b) => ((a.address?.[sortBy] ?? '') < (b.address?.[sortBy] ?? '') ? -1 : 1));
    }
}
